import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const ChatUIContainer = superstyled({
  name: 'ChatUI',
  slot: 'Container',
  tag: Box,
  styles: ({ theme, height }) => ({
    display: 'grid',
    gridTemplateRows: '1fr auto',
    height: height || 'calc(100dvh - 4.125rem)', // 5rem is the height of the header
    margin: '0 auto',
    gap: theme.spacing(0)
  })
});

export const ChatUIFullHeightContainer = superstyled({
  name: 'ChatUI',
  slot: 'FullHeightContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100dvh - 3.925rem)',
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100dvh - 5rem)'
    },
    width: 'min(100vw, 35rem)',
    maxWidth: '35rem',
    margin: '0 auto'
  })
});

export const ChatUIContentArea = superstyled({
  name: 'ChatUI',
  slot: 'ContentArea',
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    // maxWidth: '35rem',
    // width: 'min(100vw - 2rem, 35rem)',

    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    // flex: 1, // fill available space
    // minHeight: 0, // allow shrinking
    margin: '0 auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(4)
    }
  })
});

export const ChatUICenteredContent = superstyled({
  name: 'ChatUI',
  slot: 'CenteredContent',
  tag: Box,
  styles: ({ theme }) => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
    justifyContent: 'center',
    alignItems: 'center'
  })
});

export const ChatUIInputArea = superstyled({
  name: 'ChatUI',
  slot: 'InputArea',
  tag: Box,
  styles: ({ theme }) => ({
    maxWidth: '37.5rem',
    width: 'min(100vw - 2rem, 37.5rem)',
    margin: '0 auto',
    zIndex: 10,
    position: 'sticky',
    bottom: 0,
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing(2)
    }
  })
});

export const ChatUILoadMoreSection = superstyled({
  name: 'ChatUI',
  slot: 'LoadMoreSection',
  tag: Box,
  styles: () => ({
    textAlign: 'end'
  })
});
